


















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { QueryAppByCode } from '../../api/space/index';
import { downloadByUrl } from '@/utils/file.util';

@Component({
  components: {},
})
export default class Index extends Vue {
  data = {} as any;
  showChoose = false;
  currentIndex = 0;
  mounted() {
    this.getDetail();
  }

  async getDetail() {
    await QueryAppByCode({ code: this.$route.query.code }).then(res => {
      this.data = res;
    });
  }

  download() {
    if (this.data.platformMap.Win && this.data.platformMap.Mac) {
      this.showChoose = true;
    } else {
      if (this.data.platformMap.Win.downloadUrl.includes('redirect:')) {
        window.open(this.data.platformMap.Win.downloadUrl.replace('redirect:', ''), '_blank');
      } else {
        downloadByUrl(this.data.platformMap.Win.downloadUrl, this.data.name + '.exe');
      }
    }
  }

  handleDownload(index: number, url: string) {
    this.currentIndex = index;
    this.showChoose = false;
    downloadByUrl(url, this.data.name);
  }

  service() {
    this.$router.push('/mall');
  }
}
